import React from 'react';

import { Window } from '../../contexts';
import { Copyable, Money } from '../../components';

// `currency` is the payment's own currency code; omitted → store base.
export function TransferInformation({ amount, currency, reference }) {
  const bankAccount = Window?.BANK_TRANSFER_DETAILS?.split("\n")

  return (
    <>
      <p className="mt-2">
        Transfer <strong><Money amount={amount} currency={currency} /></strong>&nbsp;
        to our bank account with reference <strong>{reference}</strong>.
      </p>

      <div className="card bank-details">
        {bankAccount?.map((e,i) => <p key={i}><Copyable text={e} /></p>)}
      </div>
    </>
  );
}
